import $ from 'jquery'

function init() {
	const propert_data = $.getJSON('/wp-content/api-cache/properties-data.json')

	$.when(propert_data)
		.done(function (properties) {
			build_filer(properties)
		})
		.fail(function (error) {
			// eslint-disable-next-line no-console
			console.error('error', error)
		})
}

function build_filer(properties) {
	const cities = []
	const cities_temp = []

	$.each(properties, (index, property) => {
		const latlong = property.latlong ? property.latlong.split(',') : []
		const latitude = latlong[0]
		const longitude = latlong[1]

		if (latitude && longitude) {
			property.cities.map(city => {
				if (cities_temp.indexOf(city.name) == -1) {
					cities_temp.push(city.name)
					cities.push(city)
				}
			})
		}
	})

	$('#city-select').append(cities.map(city => `<option value="${city.slug}">${city.name}</option>`).join(''))
}

$(window).on('scroll', () => {
	$(window).off('scroll')
	$('#city-select').off()

	init()
})

$('#city-select').on('click', () => {
	$(window).off('scroll')
	$('#city-select').off()

	init()
})
